/**
 * Mounted once in the app shell (app-layout.tsx), after CompanionActionHost,
 * whose action hook answers the bridge's tool requests. Installs the admin
 * portal's tool bridge (admin-tool-bridge.ts) when the portal's origin is
 * configured; renders nothing.
 */

import { useEffect } from 'react'
import { useCompanionManager } from '@edge/edge-ai'
import { ADMIN_PORTAL_ORIGIN } from '@/config/constants'
import {
  installAdminToolBridge,
  runThroughCompanion,
  verifyBridgeTicket,
} from './admin-tool-bridge'

export function AdminToolBridgeHost() {
  const manager = useCompanionManager()

  useEffect(() => {
    if (!ADMIN_PORTAL_ORIGIN) return
    return installAdminToolBridge({
      portalOrigin: ADMIN_PORTAL_ORIGIN,
      win: window,
      verify: verifyBridgeTicket,
      run: (call) => runThroughCompanion(manager.events, call),
    })
  }, [manager])

  return null
}
